import { render, staticRenderFns } from "./social-links-widget.vue?vue&type=template&id=4a0e8540&lang=pug&"
import script from "./social-links-widget.vue?vue&type=script&lang=js&"
export * from "./social-links-widget.vue?vue&type=script&lang=js&"
import style0 from "./social-links-widget.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports